import { SELECTED_SURFACE } from '@/components/ui/constants';

export const FILTER_ACTIVE_CLASSES = `${SELECTED_SURFACE} [&_svg]:text-selected hover:bg-selected-soft/50`;

// Shared width for the filter submenu and the pill popover.
export const FILTER_SUBMENU_WIDTH = 'w-70';
